import {
    Component,
    EventEmitter,
    Input,
    OnChanges,
    OnDestroy,
    OnInit,
    Output,
    SimpleChanges,
} from '@angular/core';
import { FormBuilder, FormGroup } from '@angular/forms';
import { IOption } from '@cmps/ng-select';
import { Subscription } from 'rxjs';
import { tap } from 'rxjs/operators';

import {
    QuickSwitch,
    QuickSwitchItem,
    QuickSwitchTypeCriteriaIdTypeMap,
} from '../insight/config.insight.model';

import { CriteriaTypeLevelTplOptsMap } from './filter.pi.model';
import {
    LevelOptionLabel,
    LevelOptionSelectionChangeEvent,
} from './level-option.pi.model';

@Component({
    selector: '[cmpsPerformanceInsightLevelOption]',
    templateUrl: './level-option.pi.component.html',
    exportAs: 'cmpsPerformanceInsightLevelOption',
})
export class LevelOptionPerformanceInsightComponent
    implements OnChanges, OnInit, OnDestroy
{
    @Input() quickSwitch: QuickSwitch;
    @Input() filteredItems: QuickSwitchItem[];
    @Input() selected: QuickSwitchItem;
    @Output() selectionChange: EventEmitter<LevelOptionSelectionChangeEvent>;
    @Input() canChangeActive: boolean;
    form: FormGroup;
    optsLabel: LevelOptionLabel;
    @Output() optsLabelChange: EventEmitter<LevelOptionLabel>;
    opts: IOption[];
    private _sub: Subscription;

    constructor(private readonly _formBuilder: FormBuilder) {
        this.selectionChange = new EventEmitter();
        this.optsLabelChange = new EventEmitter();

        this.form = this._formBuilder.group({
            item: [null],
        });
    }

    ngOnChanges(changes: SimpleChanges): void {
        // eslint-disable-next-line no-prototype-builtins
        if (changes.hasOwnProperty('quickSwitch')) {
            if (this.quickSwitch) {
                const ct =
                    QuickSwitchTypeCriteriaIdTypeMap[
                        this.quickSwitch.quickSwitchType
                    ];
                this.optsLabel = CriteriaTypeLevelTplOptsMap[
                    ct
                ] as any as LevelOptionLabel;
                this.opts = (this.filteredItems || []).map((e) => ({
                    label: e.name,
                    value: e,
                }));
            } else {
                this.optsLabel = { label: null, placeholder: null };
                this.opts = [];
            }
            this.optsLabelChange.emit(this.optsLabel);
        }

        // eslint-disable-next-line no-prototype-builtins
        if (changes.hasOwnProperty('selected')) {
            this.form.patchValue(
                {
                    item: [this.selected],
                },
                { emitEvent: false },
            );
        }
    }

    ngOnInit(): void {
        this._sub = this.form
            .get('item')
            .valueChanges.pipe(
                tap<QuickSwitchItem>((value) => {
                    this.selectionChange.emit({ selected: value });
                }),
            )
            .subscribe();
    }

    ngOnDestroy(): void {
        if (this._sub) {
            this._sub.unsubscribe();
        }
        this.selectionChange.complete();
        this.optsLabelChange.complete();
    }
}
